import { takeLatest } from "@redux-saga/core/effects";

import { handleUIConfig } from "./handlers/uiConfig";
import { FETCH_UI_CONFIG } from "../uiConfig/uiConfigTypes";

import {
  FETCH_CNC_VOUCHER_SENT_REPORT,
  RESEND_CNC_VOUCHER,
} from "../cncVoucher/cncVoucherTypes";
import {
  FETCH_CNC_MANUAL_WEBORDER_STATUS,
  MODIFY_CNC_MANUAL_WEBORDER_STATUS,
  FETCH_CNC_SCANNED_WEBORDER_STATUS,
  MODIFY_CNC_SCANNED_WEBORDER_STATUS,
} from "../cncWebOrder/cncWebOrderTypes";
import {
  handleFetchCncVoucherReport,
  handleResendCncVoucher,
} from "./handlers/cncVoucher";
import {
  handleFetchCNCManualWeborderStatus,
  handleFetchCNCScannedWeborderStatus,
} from "./handlers/cncFetchWOStatus";
import {
  handleUpdateCNCManualWeborderStatus,
  handleUpdateCNCScannedWeborderStatus,
} from "./handlers/cncUpdateWOStatus";

import {
  FETCH_BALANCE_BY_WALLET,
  FETCH_BALANCE_BY_GIFT_CARD,
} from "../giftBalance/giftBalanceTypes";
import {
  handleFetchBalanceByWallet,
  handleFetchBalanceByGiftCard,
} from "./handlers/giftBalance";

import { FETCH_ORDER_BY_ORDER_NUMBER } from "../trackOrder/trackOrderTypes";
import { handleTrackOrder } from "./handlers/trackOrder";

import { FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER } from "../assemblyGuide/assemblyGuideTypes";
import { handleAssemblyGuide } from "./handlers/assemblyGuide";

import { handleFetchAssets } from "./handlers/assets";
import { FETCH_ASSETS } from "../assets/assetsTypes";

import { SEND_OTP, VERIFY_OTP } from "../login/loginTypes";
import { handleSendOtp, handleVerifyOtp } from "./handlers/login";

export function* watcherSaga() {
  yield takeLatest(FETCH_UI_CONFIG, handleUIConfig);
  yield takeLatest(FETCH_ASSETS, handleFetchAssets);
  yield takeLatest(FETCH_CNC_VOUCHER_SENT_REPORT, handleFetchCncVoucherReport);
  yield takeLatest(RESEND_CNC_VOUCHER, handleResendCncVoucher);
  yield takeLatest(FETCH_BALANCE_BY_WALLET, handleFetchBalanceByWallet);
  yield takeLatest(
    FETCH_CNC_MANUAL_WEBORDER_STATUS,
    handleFetchCNCManualWeborderStatus
  );
  yield takeLatest(
    FETCH_CNC_SCANNED_WEBORDER_STATUS,
    handleFetchCNCScannedWeborderStatus
  );
  yield takeLatest(
    MODIFY_CNC_MANUAL_WEBORDER_STATUS,
    handleUpdateCNCManualWeborderStatus
  );
  yield takeLatest(
    MODIFY_CNC_SCANNED_WEBORDER_STATUS,
    handleUpdateCNCScannedWeborderStatus
  );

  yield takeLatest(FETCH_BALANCE_BY_GIFT_CARD, handleFetchBalanceByGiftCard);
  yield takeLatest(FETCH_ORDER_BY_ORDER_NUMBER, handleTrackOrder);
  yield takeLatest(FETCH_ASSEMBLY_GUIDE_BY_ARTICLE_NUMBER, handleAssemblyGuide);
  yield takeLatest(SEND_OTP, handleSendOtp);
  yield takeLatest(VERIFY_OTP, handleVerifyOtp);
}
